import React from 'react';
import { SUPPORT_EMAIL } from '../legal/constants';
import {
  LSC_BILLING_SUPPORT_EMAIL_BODY,
  LSC_BILLING_SUPPORT_EMAIL_SUBJECT,
  LSC_BILLING_SUPPORT_HELP_LINE,
} from './billingCopy';

export function billingSupportMailtoHref(): string {
  const subject = encodeURIComponent(LSC_BILLING_SUPPORT_EMAIL_SUBJECT);
  const body = encodeURIComponent(LSC_BILLING_SUPPORT_EMAIL_BODY);
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}

interface BillingSupportContactProps {
  className?: string;
  testId?: string;
}

const BillingSupportContact: React.FC<BillingSupportContactProps> = ({
  className = 'text-xs text-secondary-500',
  testId = 'lsc-billing-support-contact',
}) => (
  <p className={className} data-testid={testId}>
    {LSC_BILLING_SUPPORT_HELP_LINE}{' '}
    <a
      href={billingSupportMailtoHref()}
      className="text-primary-300 hover:text-primary-200 underline-offset-2 hover:underline"
    >
      {SUPPORT_EMAIL}
    </a>
  </p>
);

export default BillingSupportContact;
